let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2l5lq")).then(() => parcelRequire('blyWx'));